import * as React from 'react';

function SvgDispute(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <mask id="dispute_svg__a" fill="#fff">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 3.158a1 1 0 00-1 1v8.526a1 1 0 001 1h2v4.262a.5.5 0 00.8.4l6.2-4.662h5a1 1 0 001-1V4.158a1 1 0 00-1-1H3z"
        />
      </mask>
      <path
        d="M5 13.684h1.5v-1.5H5v1.5zm.8 4.661l.902 1.2-.902-1.2zm6.2-4.661v-1.5h-.501l-.4.301.901 1.199zM3.5 4.158a.5.5 0 01-.5.5v-3a2.5 2.5 0 00-2.5 2.5h3zm0 8.526V4.158h-3v8.526h3zm-.5-.5a.5.5 0 01.5.5h-3a2.5 2.5 0 002.5 2.5v-3zm2 0H3v3h2v-3zm-1.5 1.5v4.262h3v-4.262h-3zm0 4.262c0 1.649 1.884 2.59 3.202 1.598l-1.803-2.398a1 1 0 011.601.8h-3zm3.202 1.598l6.2-4.661-1.803-2.398-6.2 4.661 1.803 2.398zM17 12.184h-5v3h5v-3zm-.5.5a.5.5 0 01.5-.5v3a2.5 2.5 0 002.5-2.5h-3zm0-8.526v8.526h3V4.158h-3zm.5.5a.5.5 0 01-.5-.5h3a2.5 2.5 0 00-2.5-2.5v3zm-3 0h3v-3h-3v3zm-4 0h4v-3h-4v3zm-7 0h7v-3H3v3z"
        fill={props.color}
        mask="url(#dispute_svg__a)"
      />
      <circle cx={7} cy={8.5} r={1} fill={props.color} />
      <circle cx={10} cy={8.5} r={1} fill={props.color} />
      <circle cx={13} cy={8.5} r={1} fill={props.color} />
    </svg>
  );
}

export default SvgDispute;
